import {ReactElement} from 'react'
import {Container, Description, PageImage, ReturnToDashboardButton, Title} from './styles'
import ContentImage from './assets/content.png'
import {MTPlatform} from './components/MTPlatform'
import {Trans} from 'react-i18next'
import messages from '../../../../assets/messages'

type WebtraderErrorMessageProps = {
  onClose?: () => void
}

export function WebtraderErrorMessage(props: WebtraderErrorMessageProps): ReactElement {
  return (
    <Container>
      <PageImage src={ContentImage} />
      <Title>
        <Trans {...messages.webtraderErrorMessageTitle} />
      </Title>
      <Description>
        <Trans {...messages.webtraderErrorMessageContent} />
      </Description>
      <MTPlatform />
      <ReturnToDashboardButton onClick={props.onClose}>
        <Trans {...messages.webtraderErrorMessageButton} />
      </ReturnToDashboardButton>
    </Container>
  )
}
